import classnames from 'classnames'
import React from 'react'

import styles from './Tube.module.css'

type Props = {
  children: React.ReactNode
  className?: string
  foregroundColor?: string
  backgroundColor?: string
  outlined?: boolean
  rounded?: boolean
  roundedLeft?: boolean
  roundedRight?: boolean
  roundedTopLeft?: boolean
  roundedTopRight?: boolean
  roundedBottomLeft?: boolean
  roundedBottomRight?: boolean
}

const Tube = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      children,
      outlined,
      rounded,
      roundedLeft,
      roundedRight,
      backgroundColor,
      foregroundColor = '#fff',
      roundedTopLeft,
      roundedTopRight,
      roundedBottomLeft,
      roundedBottomRight,
      className = ''
    },
    ref
  ) => {
    const outlinedStyles = outlined
      ? { border: `1px solid ${foregroundColor}` }
      : {}

    return (
      <div
        style={{ backgroundColor, color: foregroundColor, ...outlinedStyles }}
        ref={ref}
        className={classnames(className, styles.Tube, {
          [styles.RoundTopLeft]: roundedTopLeft || rounded || roundedLeft,
          [styles.RoundTopRight]: roundedTopRight || rounded || roundedRight,
          [styles.RoundBottomLeft]: roundedBottomLeft || rounded || roundedLeft,
          [styles.RoundBottomRight]:
            roundedBottomRight || rounded || roundedRight
        })}
      >
        <div className={styles.TubeContent}>{children}</div>
      </div>
    )
  }
)

export default Tube
